const NotEqualSignIcon = /*#__PURE__*/ [
  ["path", { d: "M4 8H20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 16H20", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 20L18 4", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }]
];

export { NotEqualSignIcon as default };
//# sourceMappingURL=NotEqualSignIcon.js.map
